export const CREATE_LEGAL = 'legal-modal/CREATE_LEGAL';
export const createLegalAction = payload => ({
	type: CREATE_LEGAL,
	payload,
});

export const GET_LEGAL_INFO = 'legal-modal/GET_LEGAL_INFO';
export const getLegalInfoAction = payload => ({
	type: GET_LEGAL_INFO,
	payload,
});

export const SET_LEGAL_INFO = 'legal-modal/SET_LEGAL_INFO';
export const setLegalInfoAction = payload => ({
	type: SET_LEGAL_INFO,
	payload,
});

export const SET_IS_LEGAL_INFO_LOADING = 'legal-modal/SET_IS_LEGAL_INFO_LOADING';
export const setIsLegalInfoLoadingAction = payload => ({
	type: SET_IS_LEGAL_INFO_LOADING,
	payload,
});

export const DELETE_LEGAL = 'legal-modal/DELETE_LEGAL';
export const deleteLegalAction = payload => ({
	type: DELETE_LEGAL,
	payload,
});

export const UPDATE_LEGAL = 'legal-modal/UPDATE_LEGAL';
export const updateLegalAction = payload => ({
	type: UPDATE_LEGAL,
	payload,
});

export const SET_IS_LEGAL_UPDATING = 'legal-modal/SET_IS_LEGAL_UPDATING';
export const setIsLegalUpdatingAction = payload => ({
	type: SET_IS_LEGAL_UPDATING,
	payload,
});

export const SET_IS_LEGAL_DELETING = 'legal-modal/SET_IS_LEGAL_DELETING';
export const setIsLegalDeletingAction = payload => ({
	type: SET_IS_LEGAL_DELETING,
	payload,
});

export const RESET_STATE = 'legal-modal/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});

export const SET_LEGAL_SEARCH_VALUE = 'legal-modal/SET_LEGAL_SEARCH_VALUE';
export const setLegalSearchValueAction = payload => ({
	type: SET_LEGAL_SEARCH_VALUE,
	payload,
});

export const GET_LEGALS_OPTIONS = 'legal-modal/GET_LEGALS_OPTIONS';
export const getLegalsOptionsAction = payload => ({
	type: GET_LEGALS_OPTIONS,
	payload,
});

export const SET_LEGALS_OPTIONS = 'legal-modal/SET_LEGALS_OPTIONS';
export const setLegalsOptionsAction = payload => ({
	type: SET_LEGALS_OPTIONS,
	payload,
});

export const SET_IS_LEGALS_OPTIONS_LOADING = 'legal-modal/SET_IS_LEGALS_OPTIONS_LOADING';
export const setIsLegalsOptionsLoadingAction = payload => ({
	type: SET_IS_LEGALS_OPTIONS_LOADING,
	payload,
});
